const items = [
  {
    title: "Bathroom renovations",
    img: "https://customer-assets.emergentagent.com/job_interior-wny/artifacts/6n494q9h_IMG_3266.png",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    title: "Full bathroom remodels",
    img: "https://customer-assets.emergentagent.com/job_interior-wny/artifacts/b983c8p8_IMG_3894.jpg",
    span: "md:col-span-2",
  },
  {
    title: "Tub & shower surrounds",
    img: "https://customer-assets.emergentagent.com/job_interior-wny/artifacts/vae949nj_IMG_3602.jpg",
    span: "md:col-span-1",
  },
  {
    title: "Hardwood & vinyl flooring",
    img: "https://images.unsplash.com/photo-1560184897-1ee3713708ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxoYXJkd29vZCUyMGZsb29yJTIwbGl2aW5nJTIwcm9vbXxlbnwwfHx8fDE3NzgxMTk3MjF8MA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-1",
  },
  {
    title: "Interior painting & light fixtures",
    img: "https://customer-assets.emergentagent.com/job_interior-wny/artifacts/4z4wnq12_IMG_3975.jpg",
    span: "md:col-span-2",
  },
  {
    title: "Window installs",
    img: "https://customer-assets.emergentagent.com/job_interior-wny/artifacts/x77llxbw_IMG_3653.jpg",
    span: "md:col-span-2",
  },
];

export default function Work() {
  return (
    <section
      id="work"
      data-testid="work-section"
      className="py-24 md:py-32 bg-brand-ink text-white"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-12">
          <div className="lg:col-span-8">
            <p className="eyebrow">Project Types</p>
            <h2 className="mt-3 font-display text-4xl md:text-5xl lg:text-6xl font-black leading-[1.02] tracking-tight">
              From small repairs to{" "}
              <span className="text-brand-rust">full room transformations.</span>
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-white/70 leading-relaxed max-w-md">
              A snapshot of the kind of work we take on across Western New York.
              Clean prep, careful finishes, jobsite respected like it's our own
              house.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[220px] md:auto-rows-[260px] gap-3 md:gap-4">
          {items.map((it, i) => (
            <div
              key={it.title}
              data-testid={`work-tile-${i}`}
              className={`relative overflow-hidden border border-white/10 group ${it.span}`}
            >
              <img
                src={it.img}
                alt={it.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute left-5 bottom-5 right-5">
                <p className="text-[11px] uppercase tracking-[0.22em] font-bold text-brand-rust">
                  0{i + 1}
                </p>
                <h3 className="mt-1 font-display text-xl md:text-2xl font-bold text-white">
                  {it.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
